import { useMediaQuery } from '@mui/material';
import Cookies from 'js-cookie';
import styled from 'styled-components';

import { media } from 'atoms/breakpoints/breakpoints';

import Flex from 'quarks/Flex';
import Heading from 'quarks/Heading';

import Button from 'molecules/Button/Button';

import Form from 'components/Form';

export const ExpandContent = ({ onClick }: { onClick: () => void }) => (
  <ExpandContainer data-testid="expand-content" className="expand-content" onClick={onClick}>
    <ExpandedRow>
      <Flex flexDirection="column">
        <Button
          sm={{ maxWidth: '100%' }}
          textTransform="none"
          zIndex={1}
          variant="navy-outlined"
          width="100%"
          onClick={onClick}
        >
          Expand to read more
        </Button>
      </Flex>
    </ExpandedRow>
    <Blur data-testid="blur-container" className="blur-container expand" />
  </ExpandContainer>
);

export const GatedForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const isTablet = useMediaQuery(media.md);

  return Cookies.get('email') ? (
    <ExpandContent onClick={onSuccess} />
  ) : (
    <ExpandContainer data-testid="gated-content" className="gated-content">
      <EmailContainer>
        <Flex flexDirection="row" gap="24" justifyContent="space-between">
          <Heading as="h3" fontSize="h4" fontWeight="semiBold" marginTop={10} display="none" md={{ display: 'block' }}>
            Subscribe to continue reading
          </Heading>
          <Form
            buttonLabel={isTablet ? 'Subscribe' : 'Subscribe to read more'}
            formType="Inline Subscribe"
            onSuccess={onSuccess}
          />
        </Flex>
      </EmailContainer>
      <Blur data-testid="blur-container" className="blur-container" />
    </ExpandContainer>
  );
};

const blurCss = 'to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1)';

const Blur = styled.div`
  position: absolute;
  width: 110%;
  height: 290px;
  bottom: 0px;
  margin: 0 0 0 -5%;
  backdrop-filter: blur(3px);
  background: linear-gradient(${blurCss} 70%);
  mask-image: linear-gradient(to top, black 0%, black 100%), linear-gradient(to top, transparent 0%, black 100%),
    linear-gradient(to right, transparent 0%, black 100%), linear-gradient(to bottom, transparent 0%, black 100%),
    linear-gradient(to left, transparent 0%, black 100%);
  mask-position: center, top, right, bottom, left;
  mask-size: 100% 100%, 100% 40px, 10px 100%, 100% 0px, 10px 100%;
  mask-repeat: no-repeat;
  mask-composite: source-out, source-over, source-over;

  @media (max-width: 767px) {
    height: 390px;
    background: linear-gradient(${blurCss} 40%);

    &.expand {
      height: 260px;
      background: linear-gradient(${blurCss} 90%);
    }
  }
`;

const EmailContainer = styled.div`
  position: absolute;
  bottom: 0;
  z-index: 2;
  width: 100%;
  button {
    text-transform: none;
  }
  & > div {
    padding: 0px;
    display: flex;
    flex-direction: row;
    background: linear-gradient(${blurCss} 70%);
    & > div {
      width: 50%;
      text-align: left;

      .MuiFormControl-root {
        min-width: unset !important;
      }

      p,
      span {
        color: black;
      }
      p {
        margin-left: -100%;
      }
      a {
        color: black;
        text-decoration: underline;
      }
    }
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 20px;
      h3 {
        width: 100%;
      }
      & > div {
        width: 100%;
        p {
          margin-left: 0;
        }
      }
    }
  }
`;

const ExpandContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  .blur-container.mod {
      background: linear-gradient(${blurCss} 60%);
    }
  }
  @media (max-width: 767px) {
    &.gated-content {
      .blur-container {
        height: 370px;
        background: linear-gradient(${blurCss} 30%);
        &.mod {
          background: linear-gradient(${blurCss} 23%);
        }
      }
    }
  }
`;

const ExpandedRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  position: absolute;
  bottom: 0;
  margin: 0 !important;
  & > div {
    padding: 0 !important;
    width: 100%;
  }
`;
